import React from 'react'
import { Box, Typography, Grid, useTheme, Button, Paper } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import { transferData } from 'data/residencyTransfers/data'
import ResidencyTransferCard from './ResidencyTransferCard'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const ResidencyTransferPage = () => {
  const theme = useTheme()
  const signedIn = useSelector(state => state.identity.signedIn)

  const renderAuthContent = () => (
    <Grid container item xs={12} justifyContent='center' sx={{ marginTop: '20px' }}>
      <Grid container item xs={11}>
        <Typography 
          variant="body2" 
          sx={{ 
            mb: 3, 
            color: theme.palette.text.secondary,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5 
          }}
        >
          <EmailIcon fontSize="small" />
          Click the contact button to reach out to residents directly about transfer opportunities
        </Typography>
      </Grid>

      <Grid container item xs={11} spacing={3}>
        {transferData.map((transfer) => (
          <Grid item xs={12} sm={6} lg={4} key={transfer.id}>
            <ResidencyTransferCard transfer={transfer} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  )

  const renderUnauthContent = () => (
    <Grid container item xs={12} justifyContent='center' sx={{ marginTop: '20px' }}>
      <Grid container item xs={11} md={8}>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '8px',
            border: `1px solid ${theme.palette.grey[300]}`,
            boxShadow: theme.shadows[3],
            textAlign: 'center',
            mt: 4
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, color: theme.palette.primary.main }}>
            Sign In Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Please sign in or create an account to view residency transfer opportunities
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              component={Link}
              to="/login"
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                }
              }}
            >
              Sign In
            </Button>
            <Button
              variant="outlined"
              component={Link}
              to="/register/physicians"
              sx={{
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                '&:hover': {
                  borderColor: theme.palette.primary.dark,
                  backgroundColor: theme.palette.primary.light,
                }
              }}
            >
              Sign Up
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )

  return (
    <Box>
      <Grid container spacing={0} sx={{ 
        width: '100%',
        m: 0,
        p: 0,
        mt: 0,
        pt: 0
      }}>
        <Grid item xs={12} sx={{ 
          width: '100%',
          m: 0,
          p: 0,
          mt: 0,
          pt: 0
        }}>
          <Paper 
            elevation={0} 
            sx={{ 
              width: '100%', 
              mb: 4,
              backgroundColor: theme.palette.background.dark,
              borderRadius: '0px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              mx: 0,
              mt: 0,
              pt: 0
            }}
          >
            <Box sx={{ maxWidth: '91.666667%', mx: 'auto', p: { xs: 2, md: 3 } }}>
              <Grid container spacing={0} sx={{ px: 0 }}>
                <Grid item xs={12} md={8} sx={{ pl: 0 }}>
                  <Typography variant='h5' sx={{ 
                    color: 'white',
                    fontWeight: 'bold',
                    mb: 1,
                    pl: 0
                  }}>
                    Residency Transfer
                  </Typography>
                  <Typography variant='caption' sx={{ 
                    color: 'rgba(255,255,255,0.7)',
                    display: 'block',
                    mb: { xs: 2, md: 0 },
                    whiteSpace: 'normal',
                    wordBreak: 'normal',
                    pl: 0
                  }}>
                    We're creating a free platform to help residents find transfer opportunities and programs fill vacancies. 
                    Your input will help us build features that matter most to the medical community.
                  </Typography>
                </Grid>
                <Grid 
                  item 
                  xs={12} 
                  md={4} 
                  sx={{ 
                    display: 'flex', 
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: { xs: 'flex-start', md: 'flex-end' },
                    pl: 0
                  }}
                >
                  <Button 
                    variant='contained' 
                    color='primary'
                    startIcon={<EmailIcon />}
                    href="https://forms.gle/LeAZ56xtLz9qMx4T7"
                    target="_blank"
                    sx={{ 
                      minWidth: { xs: '100%', md: 'auto' },
                      py: 1.5,
                      px: 3,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      '&:hover': {
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                      }
                    }}
                  >
                    Transfer Programs
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      {signedIn ? renderAuthContent() : renderUnauthContent()}
    </Box>
  )
}

export default ResidencyTransferPage 